
const eventview = [{"key":"eventview.title","string":"Ihre Veranstaltungen"},{"key":"eventview.add_event_button","string":"Veranstaltung hinzufügen"},{"key":"eventview.no_event_added","string":"Sie haben noch keine Veranstaltungen hinzugefügt."},{"key":"eventview.table.title","string":"Name"},{"key":"eventview.table.location","string":"Veranstaltungsort"},{"key":"eventview.table.date","string":"Datum"},{"key":"eventview.gotowebsite","string":"Internetseite der Veranstaltung"}]

export default eventview



// WEBPACK FOOTER //
// ./src/i18n/de/addevent/eventview.js